import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Totals for the "My Recordings" cloud badge — {sessions, takes, bytes}. */
export async function fetchRecordingStats() {
  const { data } = await axios.get(`${API}/recording/stats`, { withCredentials: true, timeout: 8_000 });
  return { sessions: data?.sessions || 0, takes: data?.takes || 0, bytes: data?.bytes || 0 };
}

export function fmtBytesShort(b) {
  if (!b || b < 0) return "0 B";
  if (b < 1024) return `${b} B`;
  if (b < 1024 * 1024) return `${(b / 1024).toFixed(0)} KB`;
  if (b < 1024 * 1024 * 1024) return `${(b / 1024 / 1024).toFixed(1)} MB`;
  return `${(b / 1024 / 1024 / 1024).toFixed(2)} GB`;
}

/** Recording `files` values are either full `/api/recording/file/...` paths
 *  or (legacy single takes) bare filenames — resolve both to absolute URLs. */
export function recordingFileUrl(sessionId, value) {
  if (!value) return "";
  if (/^https?:\/\//i.test(value)) return value;
  const path = value.startsWith("/") ? value : `/api/recording/file/${sessionId}/${value}`;
  return `${process.env.REACT_APP_BACKEND_URL}${path}`;
}
